import { useState, useEffect } from "react";
import dayjs from "dayjs";

function useClock(timeLapse = 0) {
  const [date, setDate] = useState(dayjs());

  const tick = () => {
    setDate(dayjs());
  };

  useEffect(() => {
    let clockID = setInterval(() => tick(), timeLapse);

    return () => {
      clearInterval(clockID);
    };
  }, [timeLapse]);

  return date.format("HH:mm");
}

export { useClock };
